export default "__VITE_ASSET__DpEgLBPJ__";